import USER_ROLES from '../../utils/UserRoles';
import FilterDefinitionTypes from './FilterDefinitionTypes';
import ComparisonOperators from './ComparisonTypes';

export default class FilterDefinition {
  type;

  value;

  label;

  key;

  disabledForRoles = [USER_ROLES.USER];

  hiddenForRoles = [USER_ROLES.USER];

  validValues;

  allowNone = true;

  dateComparisonOperator = ComparisonOperators.EQ;
  dateComparisonKey;

  constructor(type = FilterDefinitionTypes.VALUE, value = '', label = '', key = '') {
    this.type = type;
    this.value = value;
    this.label = label;
    this.key = key;
  }
}
